import { FC, Fragment, useCallback } from "react";
import Stack from "@mui/material/Stack";
import { Button, IconButton, Skeleton, Typography } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { Close } from "@mui/icons-material";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { budgetDetailsByIdDataSelector } from "@/store/budgets/selectors/details-drawer/budgetDetailsByIdDataSelector";
import { BudgetIcon } from "@/components/pages/budgets-and-alerts/components/grids/budgets/components/BudgetIcon";
import { initiateBudgetByIdThunk } from "@/store/budgets/thunks/initiateBudgetByIdThunk";
import { toggleAlertsOpenDrawer } from "@/store/alerts/alertsSlice";
import { useAppAbility } from "@/services/permissions";
import { closeBudgetDetailsDrawerThunk } from "@/store/budgets/thunks/drawer/closeBudgetDetailsDrawerThunk";
import { budgetDetailsByIdLoadingSelector } from "@/store/budgets/selectors/details-drawer/budgetDetailsByIdLoadingSelector";

export const BudgetDetailsMainHeader: FC = () => {
  const dispatch = useAppDispatch();
  const budgetDetails = useAppSelector(budgetDetailsByIdDataSelector);
  const loading = useAppSelector(budgetDetailsByIdLoadingSelector);

  const name = budgetDetails?.name;
  const isFilterBudget = !budgetDetails?.view && !!budgetDetails?.filter_tree;

  const { can } = useAppAbility();
  const canEditBudget = can("edit", "budget");

  const clickHandler = useCallback(() => {
    if (!budgetDetails?.id) {
      return;
    }

    dispatch(toggleAlertsOpenDrawer());
    dispatch(initiateBudgetByIdThunk(budgetDetails.id));
  }, [dispatch, budgetDetails?.id]);

  const closeHandler = useCallback(() => {
    dispatch(closeBudgetDetailsDrawerThunk());
  }, [dispatch]);

  return (
    <Stack
      direction="row"
      px={2}
      py={1.25}
      alignItems="center"
      justifyContent="space-between"
    >
      <Stack direction="row" spacing={1.5} alignItems="center">
        {loading ? (
          <Fragment>
            <Skeleton
              width={30}
              height={30}
              variant="rectangular"
              sx={{
                borderRadius: 2,
              }}
            />
            <Skeleton width={150} height={24} />
          </Fragment>
        ) : (
          <Fragment>
            <BudgetIcon
              base={isFilterBudget ? "filters" : "billingExplorerReport"}
            />

            <Typography variant="body1" fontWeight="medium">
              {name}
            </Typography>
          </Fragment>
        )}
      </Stack>

      <Stack direction="row" spacing={1.5} alignItems="center">
        <Button
          size="small"
          variant="outlined"
          onClick={clickHandler}
          disabled={!canEditBudget || loading}
          startIcon={<EditOutlinedIcon fontSize="small" />}
        >
          Edit
        </Button>
        <IconButton size="small" onClick={closeHandler}>
          <Close fontSize="medium" />
        </IconButton>
      </Stack>
    </Stack>
  );
};
